<app-main [model]="model" [electionName]="null"></app-main>